"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientWithPendingRoc = exports.patientWithActiveStatus = exports.patientWithPendingSoc = void 0;
const models_1 = require("../../models");
const patientStatus = 2;
exports.patientWithPendingSoc = {
    id: "6258fd8b0c7ca0001c2a23db",
    status: models_1.GROUP_STATUS.ACTIVE,
    patientStatus,
    type: models_1.USER_TYPE.PATIENT,
    meta: "s",
    name: "Sanjay Leela",
    uuid: "2f72748d-b46f-446c-940a-e9ba1b7d2f8c",
    servicesToPatient: [
        {
            status: models_1.SERVICE_STATUS.PENDING,
            id: "5e53a26f8bdcf86e1ca59a3a",
            name: "Skilled Nurse",
            shorthand: models_1.CLINICIAN_ROLES.SN,
        },
    ],
    distance: 0,
    location: {
        coordinates: [-89.5, 44.5],
        type: models_1.LOCATION_TYPE.Point,
    },
};
exports.patientWithActiveStatus = {
    id: "6179254e161b5f001c4e2a85",
    status: models_1.GROUP_STATUS.ACTIVE,
    patientStatus: 3,
    type: models_1.USER_TYPE.PATIENT,
    meta: "ww",
    name: "job jobn",
    uuid: "5ccb6636-7336-478b-afee-8ff9d22d5039",
    servicesToPatient: [
        {
            status: models_1.SERVICE_STATUS.PENDING,
            id: "5e53a26f8bdcf86e1ca59a3e",
            name: "Physical Therapist",
            shorthand: models_1.CLINICIAN_ROLES.PT,
        },
    ],
    distance: 0,
    location: {
        coordinates: [-89.5, 44.5],
        type: models_1.LOCATION_TYPE.Point,
    },
};
exports.patientWithPendingRoc = {
    id: "6179254e161b5f001c4e2a85",
    status: models_1.GROUP_STATUS.ACTIVE,
    patientStatus: 5,
    type: models_1.USER_TYPE.PATIENT,
    meta: "ww",
    name: "job jobn",
    uuid: "5ccb6636-7336-478b-afee-8ff9d22d5039",
    servicesToPatient: [
        {
            status: models_1.SERVICE_STATUS.PENDING,
            id: "5e53a26f8bdcf86e1ca59a3e",
            name: "Physical Therapist",
            shorthand: models_1.CLINICIAN_ROLES.PT,
        },
    ],
    distance: 0,
    location: {
        coordinates: [-89.5, 44.5],
        type: models_1.LOCATION_TYPE.Point,
    },
};
